import { GroupProps } from '@mantine/core';
import { Group } from '@zorro/web/design-system';
import { forwardRef } from 'react';

import { AppLayoutConstants } from '../AppLayoutUtils';

type Props = GroupProps;

export const AppLayoutSubHeader = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }: Props, ref) => {
    return (
      <Group
        style={{ zIndex: AppLayoutConstants.HEADER_ZINDEX + 1 }}
        w="calc(100% - 2 * var(--mantine-spacing-sm))"
        h="var(--app-layout-subheader-height)"
        mx="sm"
        pos="relative"
        ref={ref}
        {...props}
      >
        {children}
      </Group>
    );
  }
);
